import { render, staticRenderFns } from "./CocinaeasylunchreporteQuicktable.vue?vue&type=template&id=78bbac16&"
import script from "./CocinaeasylunchreporteQuicktable.vue?vue&type=script&lang=js&"
export * from "./CocinaeasylunchreporteQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports